// Shared presentation helpers for the notifications feature (#259).
// Colours map onto the RMDV azure theme tokens in styles/ds.css (semantic
// severity colours + the accent), so the bell popover and the Settings page read
// as one system in both light and dark themes.

// Severity → the `.dot` colour class (ds.css) + a human label.
export const SEVERITY = {
  critical: { dot: 'error', label: 'Critical', badge: 'error' },
  warning: { dot: 'warning', label: 'Warning', badge: 'warning' },
  info: { dot: 'accent', label: 'Info', badge: 'accent' },
};

export const severityOf = (s) => SEVERITY[s] || SEVERITY.info;

// Type chip label (server/org/project/user/billing).
export const TYPE_LABEL = {
  server: 'Server',
  org: 'Org',
  project: 'Project',
  user: 'You',
  billing: 'Billing',
};

// State pill: the primary column on the Settings list. `badge` is the ds.css
// `.badge` variant; `label` the human word.
export const STATE_PILL = {
  unseen: { label: 'New', badge: 'accent' },
  seen: { label: 'Seen', badge: 'neutral' },
  viewed: { label: 'Viewed', badge: 'neutral' },
  addressed: { label: 'Addressed', badge: 'success' },
  dismissed: { label: 'Dismissed', badge: 'neutral' },
};

export const TERMINAL_STATES = ['addressed', 'dismissed'];
export const ACTIVE_STATES = ['unseen', 'seen', 'viewed'];

/**
 * Badge model for the bell (updated design):
 *  - 0 unseen  → hidden (no dead affordance)
 *  - exactly 1 → a dot
 *  - several   → a count (`3`, `9+`)
 */
export function badgeModel(unseen) {
  const n = Number(unseen) || 0;
  if (n <= 0) return { kind: 'none' };
  if (n === 1) return { kind: 'dot' };
  return { kind: 'count', text: n > 9 ? '9+' : String(n) };
}

// Compact relative time ("just now", "3m", "2h", "5d", else a short date).
export function relativeTime(iso) {
  if (!iso) return '';
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return '';
  const secs = Math.floor((Date.now() - then) / 1000);
  if (secs < 45) return 'just now';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d`;
  try {
    return new Date(then).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  } catch {
    return '';
  }
}
